module.exports = __webpack_public_path__ + "static/banner-img-3de5f00312bd47c7fc0fc9d639d8263a.svg";